// @ts-strict-ignore
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ArticleVO } from '@article/model/vo/article.vo';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  standalone: false,
  templateUrl: './project-request-unavailable-articles.component.html',
  selector: 'app-project-request-unavailable-articles',
})
export class ProjectRequestUnavailableArticlesComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  public showArticleList: boolean;
  @Input()
  public unavailableArticles: ArticleVO[];
  @Output()
  public finish = new EventEmitter<boolean>();

  public isSortDescending: boolean = false;

  constructor(private _bsModalRef: BsModalRef) { }

  public ngOnInit(): void {
    this.unavailableArticles.sort();
  }

  public ngAfterViewInit(): void { }

  public ngOnDestroy(): void {
  }

  public close(proceed: boolean): void {
    this.finish.emit(proceed);
    this._bsModalRef.hide();
  }

  public sort(): void {
    this.isSortDescending = !this.isSortDescending;
    this.unavailableArticles.reverse();
  }
}
